/**
 * View Transition Scroll Restoration
 *
 * Cross-document view transitions (`@view-transition { navigation: auto }`)
 * can break the browser's default scroll restoration on back/forward navigation.
 * This script saves scroll position before leaving a page and restores it
 * when the user navigates back.
 */

(function () {
  const STORAGE_KEY = 'vt-scroll-';

  // Save scroll position before navigating away
  window.addEventListener('pagehide', () => {
    try {
      sessionStorage.setItem(STORAGE_KEY + location.href, window.scrollY.toString());
    } catch (e) {
      // Storage full or unavailable
    }
  });

  // Restore scroll position on back/forward navigation
  function restoreScroll() {
    // Check if this is a back/forward navigation
    const navEntry = performance.getEntriesByType('navigation')[0];
    if (!navEntry || navEntry.type !== 'back_forward') return;

    try {
      const saved = sessionStorage.getItem(STORAGE_KEY + location.href);
      if (saved !== null) {
        const y = parseInt(saved, 10);
        // Wait for view transition to finish if one is active
        if (document.startViewTransition) {
          // Small delay to let view transition settle
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              window.scrollTo(0, y);
            });
          });
        } else {
          window.scrollTo(0, y);
        }
        sessionStorage.removeItem(STORAGE_KEY + location.href);
      }
    } catch (e) {
      // Storage unavailable
    }
  }

  // Use pagereveal if available (view transition aware), otherwise pageshow
  if ('onpagereveal' in window) {
    window.addEventListener('pagereveal', restoreScroll);
  } else {
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) restoreScroll();
    });

    // Also handle regular back navigation (not from bfcache)
    window.addEventListener('DOMContentLoaded', restoreScroll);
  }
})();
